import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';

export interface ExporttModalState {
    isOpen: boolean;
    isSuccess: boolean;
}

const initialState: ExporttModalState = {
    isOpen: false,
    isSuccess: false,
};

export const slice = createSlice({
    name: 'exportModal',
    initialState,
    reducers: {
        setExportOpen: (state, action: PayloadAction<boolean>) => {
            if (action.payload == true) {
                state.isSuccess = false;
            }
            state.isOpen = action.payload;
        },
        setExportSuccess: (state, action: PayloadAction<boolean>) => {
            state.isSuccess = action.payload;
        },
    },
});

export const { setExportOpen, setExportSuccess } = slice.actions;
export const actions = slice.actions;

export const selectExportIsOpen = (state: RootState) =>
    state.exportModal.isOpen;
export const selectExportIsSuccess = (state: RootState) =>
    state.exportModal.isSuccess;

export default slice.reducer;
